module.exports = __webpack_public_path__ + "media/images/solo-50-new-047d18f38d4854e2098c065e4e322a7b.webp";